import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';
import StepCard from 'components/common/checklist/StepCard';
import { SUBSCRIBER_CARD_DATA } from 'global/checklists-helpers/SubscriberChecklistHelper';
import {
  SubscriberTaskChecklistPageStore,
  SubscriberTaskChecklistPageStoreContext,
  useSubscriberTaskChecklistPageStore,
} from 'store/pages/subscriber/subscriber-task-checklist/pageStore';
import useSubscriberTaskUrlParams from 'global/hooks/useSubscriberTaskUrlParams';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import { buildGroupContactInfoMap } from 'global/services-helpers/groupService';
import { StagesSectionStyled } from './styles';

const ChecklistOptions: React.FC = observer(() => {
  const { checklistOptions, onStepRedirect } = useSubscriberTaskChecklistPageStore();

  return (
    <StagesSectionStyled>
      {checklistOptions.map((option) => {
        const cardData = SUBSCRIBER_CARD_DATA[option.card];
        return cardData ? (
          <StepCard
            key={`${option.card}`}
            data-test-id={`step-card-${option.card}`}
            title={cardData.title}
            text={cardData.text}
            buttonState={option.buttonState}
            completionStatus={option.completionStatus}
            onActionClick={() => onStepRedirect(cardData)}
          />
        ) : null;
      })}
    </StagesSectionStyled>
  );
});

const PageContent: React.FC = observer(() => {
  const { getInitialData, returnBack, isLoading, group } = useSubscriberTaskChecklistPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <NoSidebarPageLayout
      contentWidth="narrow"
      isInitialLoading={isLoading}
      isInfoSectionLoading={isLoading}
      moreInfoBlob={buildGroupContextMoreInfoBlobProps({
        blobTitle: group?.name || '',
        generalInfoMap: { group: group?.name || '' },
        contactInfoMap: buildGroupContactInfoMap(group?.contactInfo ?? null),
      })}
      pageHeader={{
        title: 'Employee Checklist',
        onBackButtonClick: returnBack,
        spacing: 'withBreadcrumbsSection',
      }}
    >
      <ChecklistOptions />
    </NoSidebarPageLayout>
  );
});

const SubscriberTaskChecklistPage: React.FC = () => {
  const { groupId, subscriberId, entityId } = useSubscriberTaskUrlParams();

  const pageStore = useMemo(
    () =>
      new SubscriberTaskChecklistPageStore({
        groupId,
        subscriberId,
        entityId,
      }),
    [],
  );
  return (
    <SubscriberTaskChecklistPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </SubscriberTaskChecklistPageStoreContext.Provider>
  );
};

export default SubscriberTaskChecklistPage;
